import { useLanguage } from "@/contexts/LanguageContext";
import { Search, BarChart3, CheckCircle } from "lucide-react";

const HowItWorksNew = () => {
  const { t } = useLanguage();

  const steps = [
    { icon: Search, step: "01", title: t.howItWorksNew.step1Title, desc: t.howItWorksNew.step1Desc },
    { icon: BarChart3, step: "02", title: t.howItWorksNew.step2Title, desc: t.howItWorksNew.step2Desc },
    { icon: CheckCircle, step: "03", title: t.howItWorksNew.step3Title, desc: t.howItWorksNew.step3Desc },
  ];

  return (
    <section className="py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">{t.howItWorksNew.title}</h2>
          <p className="text-muted-foreground">{t.howItWorksNew.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {steps.map((s, i) => (
            <div key={i} className="relative bg-background border border-border rounded-2xl p-6 text-center">
              <span className="absolute top-4 right-4 text-xs font-bold text-muted-foreground/40">{s.step}</span>
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
                <s.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2">{s.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksNew;
